export type Proof = {
  type: string;
  created: string;
  proofPurpose: string;
  verificationMethod: string;
  jws: string;
};
